import './SlackAuthUrl.scss';

import { CopyText } from '@ui/text';
import { integrationsActions } from '@sonar-software/sonar-integrations';
import React from 'react';
import { SonarCard } from '@ui/general';
import { When } from 'react-if';

import { Button, Form, Typography } from 'antd';
import { COPY_SPECIFIC, INTEGRATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import { createAsyncSelectors, createSonarSelector } from '@lib/selectors';
import { useAction, useSonarSelector } from '@hooks';

const getSlackAuthUrlSelectors = createAsyncSelectors((state) => state.integrations.slack.get);
const slackAuthUrlSelector = createSonarSelector((state) => getSlackAuthUrlSelectors.data(state)?.link);

export const SlackAuthUrl: React.FC = () => {
	const requestSlackAuthLink = useAction(integrationsActions.requestGetSlackAuthLink);
	const isRequested = useSonarSelector(getSlackAuthUrlSelectors.isRequested);
	const authLink = useSonarSelector(slackAuthUrlSelector) ?? '';

	return (
		<SonarCard
			className='slack-auth'
			id='slack-auth'
			title={ COPY_SPECIFIC.SLACK_URL }>
			<Form name='slack-url'>
				<Typography>{ INTEGRATIONS_COPY.GENERATE_SLACK_LINK }</Typography>
				<Button
					className='slack-link-button'
					disabled={ isRequested }
					id='generate-slack-auth-url'
					onClick={ () => requestSlackAuthLink() }
					type='primary'>
					{ COPY_SPECIFIC.GENERATE_LINK }
				</Button>
				<When condition={ authLink }>
					<CopyText text={ authLink } />
				</When>
			</Form>
		</SonarCard>
	);
};
